import { Component } from '@angular/core';
import { AlertService, AuthService } from '@app/core/services';
import { BaseContextmenuComponent } from './base-contextmenu.component';


@Component({
  selector: 'credit-contextmenu',
  template: `
    <kendo-contextmenu (select)="onSelect($event)">
      <kendo-menu-item url="detalle">
        <ng-template kendoMenuItemTemplate let-item="item">
          <div class="menu-header">
            <span class="k-icon k-i-information"></span>
            Credito: {{contextItem.name}}
          </div>
        </ng-template>
      </kendo-menu-item>
      <kendo-menu-item url="ver" text="Ver pagos" icon="dollar" *ngIf="this.authService.hasPermission(['CREDITOS:EDITAR']) && contextItem?.credit_payments != null"></kendo-menu-item>
    </kendo-contextmenu>`,
  styles: [`
    .menu-header {
      color: #ff6358
    }
  `]
})
export class CreditContextmenuComponent extends BaseContextmenuComponent {  

  //Overrides
  constructor(protected authService: AuthService, protected alertService: AlertService) {
            
    super(authService, alertService);
    // console.log(this.constructor.name);   
    
  }

  //Overrides
  protected onSelect(event): void {

    // console.log(this.constructor.name + ":onSelect", event.item, this.contextItem);
    
    event.preventDefault();
    let url: string = event.item.url;

    if (url === 'ver') {

      // Ver

    }

    //Emitir evento: selected
    this.select.emit({menu: event.item, contextItem: this.contextItem});

  }

}
